import {
  useNavigateToPlaceInWorkflow,
  useSwitchToWorkflow,
} from '../../../../../hooks';
import { useDocumentNotificationNotification } from '../../../../../hooks/useDocumentNotificationNotification';
import {
  useSubscribeToDocumentStatusUpdated,
  useSubscribeToDocumentWorkflowSwitch,
  useSubscribeToTransitionPerformed,
} from '../../../../../websocketApi';
import { useWorkflowSession } from '../../../hooks';

export const useWorkflowSessionSubscriptions = () => {
  const { rootDocument, rehydrateRootDocument, workflowName } =
    useWorkflowSession();
  const navigateToPlace = useNavigateToPlaceInWorkflow();
  const switchToWorkflow = useSwitchToWorkflow();
  const documentId = rootDocument?.id ?? '';

  useSubscribeToDocumentStatusUpdated(documentId, () =>
    rehydrateRootDocument(),
  );

  useDocumentNotificationNotification(documentId);

  useSubscribeToTransitionPerformed(
    documentId,
    ({ workflow, currentPlace }) => {
      if (workflow === workflowName) {
        navigateToPlace(currentPlace);
      }
    },
  );

  useSubscribeToDocumentWorkflowSwitch(
    documentId,
    ({ workflow, currentPlace }) => {
      if (workflow !== workflowName) {
        switchToWorkflow(workflow, currentPlace);
      }
    },
  );
};
